import { render, staticRenderFns } from "./AddRewardDialog.vue?vue&type=template&id=022c7da8"
import script from "./AddRewardDialog.vue?vue&type=script&lang=js"
export * from "./AddRewardDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports